export default "__VITE_ASSET__edd6f137__"